module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_006.png
// module id = 1130
// module chunks = 0